import React from 'react';
import {observer} from "mobx-react-lite";
import { Layout } from '../modules/Layout';
import Settings from '../modules/Setting';

export const SettingsPage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Settings/>
        </Layout>
    )
});